"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _dropdown = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _ArrowDropdown = _interopRequireDefault(require("@insided/shared/icons/ArrowDropdown"));

var _constants = require("../constants");

var _common = require("@insided/shared/utils/common");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// eslint-disable-next-line no-restricted-imports
var SortingDropdown = function SortingDropdown(_ref) {
  var _SORT_OPTIONS$find;

  var totalReplies = _ref.totalReplies,
      type = _ref.type,
      currentSort = _ref.currentSort;
  var SORT_OPTIONS = [{
    label: (0, _preact.h)(_phrase.default, {
      p: "Oldest first"
    }),
    key: _constants.SORT_KEYS.OLDEST_FIRST,
    url: "?sort=".concat(_constants.SORT_KEYS.OLDEST_FIRST, "#comments")
  }, {
    label: (0, _preact.h)(_phrase.default, {
      p: "Newest first"
    }),
    key: _constants.SORT_KEYS.NEWEST_FIRST,
    url: "?sort=".concat(_constants.SORT_KEYS.NEWEST_FIRST, "#comments")
  }, {
    label: (0, _preact.h)(_phrase.default, {
      p: "replies.sort.most.liked"
    }),
    key: _constants.SORT_KEYS.BEST_VOTED,
    url: "?sort=".concat(_constants.SORT_KEYS.BEST_VOTED, "#comments")
  }];
  var topicUrl = typeof window !== 'undefined' ? window.location.pathname : '';
  var defaultSortOption = SORT_OPTIONS[_common.common.isModuleActive('sortRepliesByNewestFirst') ? 1 : 0];
  var selectedSortOption = (_SORT_OPTIONS$find = SORT_OPTIONS.find(function (sort) {
    return sort.key === currentSort;
  })) !== null && _SORT_OPTIONS$find !== void 0 ? _SORT_OPTIONS$find : defaultSortOption;

  if (totalReplies <= 1 || type === 'productUpdate') {
    return null;
  }

  return (0, _preact.h)("div", {
    className: "list__items--sort-replies qa-topic-sort-dropdown"
  }, (0, _preact.h)(_dropdown.default, {
    isControl: false,
    openAlwaysOnTriggerClick: true,
    size: "full-width",
    align: "right",
    popupName: "sort-dropdown",
    closeOnDropdownClick: true,
    trigger: function trigger(isOpen) {
      return (0, _preact.h)("div", {
        className: "qa-reply-sort-dropdown dropdown-links__active-sort"
      }, (0, _preact.h)(_phrase.default, {
        p: "replies.sortby"
      }), ":\xA0", (0, _preact.h)("b", null, selectedSortOption.label), (0, _preact.h)(_ArrowDropdown.default, {
        className: "dropdown-links__sort-icon ".concat(isOpen ? 'dropdown-links__sort-icon--open' : '')
      }));
    }
  }, SORT_OPTIONS.filter(function (sort) {
    return sort.key !== selectedSortOption.key;
  }).map(function (sort) {
    return (0, _preact.h)(_dropdown.DropdownItem, {
      key: sort.key
    }, (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)("".concat(topicUrl, "?sort=").concat(sort.key, "#comments")),
      "data-qa": "sort-".concat(sort.key)
    }, sort.label));
  })));
};

var _default = SortingDropdown;
exports.default = _default;